import React from "react";
import styled from "styled-components";
import projectlogo from "../images/projectlogo.svg";
import { Description, Section } from "../styles";
import { Link } from "react-router-dom";
import { useScroll } from "./useScroll";
import { pageAnimation } from "../pageAnimation";
const ProjectSection = () => {
  const [element, controls] = useScroll();
  return (
    <Link
      style={{ textDecoration: "none", color: "black" }}
      className="link"
      to="/projects"
    >
      <SectionProj
        ref={element}
        variants={pageAnimation}
        animate={controls}
        initial="before"
      >
        <div className="image-div">
          <img src={projectlogo} alt="" />
        </div>
        <DiscriptionStyled>
          <div className="intro">
            <h2>
              Here are my <span>projects</span>,
            </h2>
            <p>
              I am familiar with these Technologies:
              HTML-5,CSS-3,JavaScript,React.js,Python,Django,
              C,C++,Java,Git,Github,Netlify and learning continuosly....
            </p>
          </div>
        </DiscriptionStyled>
      </SectionProj>
    </Link>
  );
};

const SectionProj = styled(Section)`
  margin: 4rem 2rem;
  padding: 1rem;
  text-decoration: none;
  display: flex;
  overflow-x: hidden;
  .intro {
    margin-left: 2rem;
    h2 {
      font-size: 240%;
      span {
        color: #8b73ff;
      }
    }
  }
`;
const DiscriptionStyled = styled(Description)`
  p {
    padding: 0rem 1rem 1rem 0rem;
    font-size: 1.2rem;
  }
  @media screen and (max-width: 786px) {
    width: 80%;
    max-width: 80%;
  }
`;

export default ProjectSection;
